import LoLExaminationProgressBar from './LoLExaminationProgressBar';

export default LoLExaminationProgressBar;
